<!-- 
    *@FileDescription: 侧边栏
    *@Author: swt
    *@LastEditors: swt
    *@LastEditTime: 2023.10.7
 -->
<template>
    <!-- <div>侧边栏</div> -->
    <el-row class="menu-wrapper">
        <el-col :span="24">
            <div style="display: flex;justify-content: center;align-items: center;height: 80px;">
                <img src="@/assets/logo.jpg" alt="" style="width: 80px;">
                <span style="font-size: 16px;font-weight: bold;">劳务派遣管理中心 </span>
            </div>
            <!-- <h5>联动中心</h5> -->
            <div style="height:calc(100vh - 80px);overflow-y: auto;">
                <el-menu :default-active="activeIndex" :router="true" ref="menu" :unique-opened="true" @select="menuSelect">
                    <el-menu-item index="/dashboard">
                        <i class="el-icon-s-data"></i>
                        <span>仪表盘</span>
                    </el-menu-item>
                    <!-- v-if="permissions.indexOf('')" -->
                    <el-submenu index="1" v-if="permissions.includes('learn_manage')">
                        <template slot="title">
                            <i class="el-icon-reading"></i>
                            <span slot="title">学习管理</span>
                        </template>
                        <el-menu-item index="questionBank">
                            题库管理</el-menu-item>
                        <el-menu-item index="examPaper">
                            试卷管理</el-menu-item>
                        <el-menu-item index="LearnRecord">
                            学习记录</el-menu-item>
                    </el-submenu>
                    <el-submenu index="2" v-if="permissions.includes('require_audit')">
                        <template slot="title">
                            <i class="el-icon-magic-stick"></i>
                            <span>需求审核</span>
                        </template>
                        <el-menu-item index="recruitAudit">
                            招工审核</el-menu-item>
                        <el-menu-item index="jobHuntAudit">
                            求职审核</el-menu-item>
                    </el-submenu>
                    <el-submenu index="3" v-if="permissions.includes('require_manage')">
                        <template slot="title">
                            <i class="el-icon-s-help"></i>
                            <span>需求管理</span>
                        </template>
                        <el-menu-item index="recruitManage">招工需求</el-menu-item>
                        <el-menu-item index="jobHuntManage">求职需求</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="/examRegister" v-if="permissions.includes('examination_registration')">
                        <i class="el-icon-document-add"></i>
                        <span slot="title">考试登记</span>
                    </el-menu-item>
                    <el-menu-item index="/InfoNotice" v-if="permissions.includes('info_notice')">
                        <i class="el-icon-document"></i>
                        <span slot="title">资讯公告</span>
                    </el-menu-item>
                    <el-submenu index="5" v-if="permissions.includes('member_manage')">
                        <template slot="title">
                            <i class="el-icon-s-custom"></i>
                            <span>会员管理</span>
                        </template>
                        <el-menu-item index="memberRecord">会员记录</el-menu-item>
                        <el-menu-item index="buyRecord">购买记录</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="/swiperSet" v-if="permissions.includes('carousel_manage')">
                        <i class="el-icon-monitor"></i>
                        <span slot="title">轮播设置</span>
                    </el-menu-item>
                    <el-submenu index="4" v-if="permissions.includes('system_manage')">
                        <template slot="title">
                            <i class="el-icon-setting"></i>
                            <span>系统设置</span>
                        </template>
                        <el-menu-item index="feeStandard">收费标准</el-menu-item>
                        <el-menu-item index="accountManage">账号管理</el-menu-item>
                        <!-- <el-menu-item index="menuManage">菜单管理</el-menu-item> -->
                        <el-menu-item index="roleManage">角色管理</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
        </el-col>
    </el-row>
</template>
<script>
export default {
    name: 'AppAside',
    data() {
        return {
            permissions: [],
            activeIndex: '/dashboard'
        }
    },
    created() {
        this.permissions = localStorage.getItem("permissions")
        if (localStorage.getItem("permissions") == "*:*:*") {
            this.permissions = ['learn_manage', 'require_audit', 'require_manage', 'examination_registration', 'info_notice', 'member_manage', 'carousel_manage', 'system_manage']
        }
    },
    mounted() {
        this.activeIndex = this.$route.name
    },
    methods: {
        menuSelect(index, path) {
            this.activeIndex = index;
        }
    },
    // watch: {
    //     $route: {
    //         handler: function (newVal, oldVal) {
    //             console.log(newVal)
    //             this.activeIndex = newVal.path;
    //         },
    //         deep: true,
    //     },
    // },
}
</script>
<style lang="less">
.menu-wrapper {
    background-color: #fff;

    .el-submenu .el-menu-item {
        padding: 0 49px !important;
    }

    .el-submenu__title {
        font-size: 16px;
    }

    .el-submenu__title {
        &:hover {
            background-color: transparent;
        }
    }

    .el-menu-item {
        border-radius: 0 20px 20px 0;
        width: 85%;
        font-size: 16px;

        // 悬停样式
        // &:hover {
        //     border-radius: 0 20px 20px 0;
        //     background-color: #5A45AA !important;
        //     color: #fff !important;

        //     //less语法，实现鼠标悬停时icon变色
        //     i {
        //         color: #fff;
        //     }
        // }

        // 选中样式
        &.is-active {
            border-radius: 0 20px 20px 0;
            background-color: #5A45AA !important;
            color: #fff !important;

            i {
                color: #fff;
            }
        }
    }

    .el-menu {
        border: none;
    }
}
</style>